// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M5 2H19V9H5V2ZM2 11H22V13H2V11ZM5 15H19V22H5V15Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-component-divider-vertical-filled')
export default class ComponentDividerVerticalFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-divider-vertical-filled',
    }
  }
}
